import { Head, useForm } from '@inertiajs/react'
import { AppShell } from '@/layouts/AppShell'
import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { FieldError } from '@/components/feedback/FieldError'

export type TeamLoginProps = {
  defaults?: {
    email: string
    password: string
  }
}

export default function TeamLogin({ defaults }: TeamLoginProps) {
  const { data, setData, post, processing, errors, transform } = useForm({
    email: defaults?.email ?? '',
    password: defaults?.password ?? '',
  })
  const baseError = (errors as { base?: string }).base

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    transform((current) => ({ team_coach: current }))
    post('/team/login')
  }

  return (
    <AppShell>
      <Head title="チームログイン" />
      <div className="mx-auto flex min-h-[70vh] w-full max-w-md flex-col justify-center gap-8 px-4">
        <div className="text-center space-y-3">
          <h1 className="text-3xl font-semibold text-white">チームコーチ ログイン</h1>
          <p className="text-sm text-white/60">Talentbox のコーチ用ダッシュボードにアクセスします。</p>
        </div>
        <Card className="p-6 space-y-6">
          {baseError ? (
            <div className="rounded-2xl border border-danger-500/30 bg-danger-500/15 px-4 py-3 text-sm text-danger-300">
              {baseError}
            </div>
          ) : null}
          <form className="space-y-4" onSubmit={submit}>
            <div className="space-y-2">
              <label htmlFor="email" className="text-xs font-semibold text-white/70">
                メールアドレス
              </label>
              <input
                id="email"
                type="email"
                value={data.email}
                onChange={(event) => setData('email', event.target.value)}
                required
                className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm text-white placeholder:text-white/40 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/40"
              />
              <FieldError message={errors.email} />
            </div>
            <div className="space-y-2">
              <label htmlFor="password" className="text-xs font-semibold text-white/70">
                パスワード
              </label>
              <input
                id="password"
                type="password"
                value={data.password}
                onChange={(event) => setData('password', event.target.value)}
                required
                className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm text-white placeholder:text-white/40 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/40"
              />
              <FieldError message={errors.password} />
            </div>
            <Button type="submit" className="w-full" loading={processing}>
              ログイン
            </Button>
          </form>
          <p className="text-center text-sm">
            <a href="/team/password_resets/new" className="font-semibold text-brand-200 hover:text-brand-100">
              パスワードを忘れた方
            </a>
          </p>
        </Card>
        <p className="text-center text-xs text-white/40">
          コーチ登録については管理者までお問い合わせください。
        </p>
      </div>
    </AppShell>
  )
}
